import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';

// Create the app
const app = createApp(App).use(router);

// Set axios globally
app.config.globalProperties.$http = axios;

// Mount the app
app.mount('#app');
